import {
  GenericNotificationCode,
  NotificationOptions,
} from '@evologi/shared/data-access-api'

export type AdminUINotificationCode =
  | GenericNotificationCode
  | 'SELECTION_LIMIT_REACHED'

/**
 * Parse adminUi code to a notification
 * @param code - the adminUi notification code
 * @returns the notification options
 */
export function parseAdminUINotification(
  code?: AdminUINotificationCode,
): NotificationOptions {
  switch (code) {
    case 'SELECTION_LIMIT_REACHED':
      return {
        message:
          'Selection limit reached. Deselect at least one item to continue',
        color: 'error',
      }
    default:
      return {}
  }
}
